import { render, staticRenderFns } from "./SectionControls.component.vue?vue&type=template&id=5ce86fd8"
import script from "./SectionControls.component.vue?vue&type=script&lang=js"
export * from "./SectionControls.component.vue?vue&type=script&lang=js"
import style0 from "./SectionControls.component.vue?vue&type=style&index=0&id=5ce86fd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports